import { toast } from '@repo/ui'
import { type ReactNode } from 'react'

export const useCustomToast = () => {
  const newToast = (description: ReactNode) =>
    toast(description, {
      position: 'top-right',
    })

  return { newToast }
}
